import {JsonApiResponse} from '@tisa-group/cdk';
import {UmpireClub} from '@tisa-group/models';
import {Action, createSelector, State, StateContext} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {Observable, tap} from 'rxjs';
import {ClubService} from '@tisa-group/core';
import {LoadClubs} from '@store/clubs/clubs.actions';
import {patch} from '@ngxs/store/operators';

export type ClubsStateModel = Record<string, JsonApiResponse<UmpireClub[]>>;

@State<ClubsStateModel>({
  name: 'clubs',
  defaults: {},
})
@Injectable()
export class ClubsState {
  @Action(LoadClubs)
  loadClubs(
    ctx: StateContext<ClubsStateModel>,
    action: LoadClubs,
  ): Observable<JsonApiResponse<UmpireClub[]>> | JsonApiResponse<UmpireClub[]> {
    const stateClubBySeasonId = ctx.getState()[action.seasonId];

    if (stateClubBySeasonId) {
      return stateClubBySeasonId;
    }

    return this.clubService
      .list({
        include: ['additional_asset', 'image', 'teams,background_photo'].join(','),
        filter: {
          teams_squads_competitions_id: {
            rule: 'eq',
            value: action.competitionId,
          },
          teams_squads_season_id: {
            rule: 'eq',
            value: action.seasonId,
          },
        },
        sort: ['name'],
      })
      .pipe(
        tap(res =>
          ctx.setState(
            patch({
              [action.seasonId]: res,
            }),
          ),
        ),
      );
  }

  static getClubsBySeasonId(seasonId: string): (state: ClubsStateModel) => UmpireClub[] {
    return createSelector([ClubsState], (state: ClubsStateModel) => {
      return state[seasonId]?.data;
    });
  }

  constructor(readonly clubService: ClubService) {}
}
